import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PriceOfferDeletePayload } from 'api/actions/price-offer-delete/price-offer-delete-payload';
import { PriceOfferDeletePathParameters } from 'api/actions/price-offer-delete/price-offer-delete-path-parameters';
import { PriceOfferDeleteResponse } from 'api/actions/price-offer-delete/price-offer-delete-response';

type PriceOfferDeleteQueryParameters = Record<string, any>;

/**
 * The path of the PriceOfferDelete action.
 */
export const priceOfferDeleteActionPath = new SweetPath<keyof PriceOfferDeletePathParameters>(
  '/api/price-offer/delete/{priceOfferId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized PriceOfferDelete actions.
 */
export default function createPriceOfferDeleteAction(axios: AxiosInstance) {
  return function priceOfferDeleteAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: PriceOfferDeletePathParameters;
    query?: PriceOfferDeleteQueryParameters;
    payload: PriceOfferDeletePayload;
  }) {
    const path = priceOfferDeleteActionPath.insert(parameters);

    return axios.request<PriceOfferDeleteResponse, PriceOfferDeleteResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
